import React from "react";
import { ReactRouterSideNav } from "../VSETHNav/reactRouterHelper";
import { Item } from "../VSETHNav/VSETHNavbar";
import { NavItem } from "../NavItem/NavItem";
import { NavLink } from "../NavLink/NavLink";
import { LinkConstructor } from "../../types";

interface Props {
  item: Item;
  NavLink: LinkConstructor;
}
export const WASidenavItemComponent: React.FC<Props> = ({
  item: { icon: Icon, ...item },
  NavLink: RouterNavLink,
}) => {
  return item.linkProps ? (
    <RouterNavLink
      component={ReactRouterSideNav}
      {...item.linkProps}
      disabled={item.disabled}
      exact
    >
      {Icon && <Icon />}
      <span className="sidenav-text">{item.title}</span>
    </RouterNavLink>
  ) : (
    <NavItem onClick={item.onClick}>
      <NavLink active={item.active} disabled={item.disabled} href={item.href}>
        {Icon && <Icon />}
        <span className="sidenav-text">{item.title}</span>
      </NavLink>
    </NavItem>
  );
};
